import React, { FormEvent, ReactNode } from 'react';
import styled from 'styled-components';
import FormLoader, { FormContainer } from '../Loaders/FormLoader';

export interface Props {
  isLoading?: boolean;
  children: ReactNode;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onEscape?: () => void;
}

export const Layout = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MainContent = styled.div`
  flex: 1;
`;

interface SideBarProps {
  width?: string;
}

export const SideBar = styled.div<SideBarProps>`
  width: ${props => props.width || '500px'};
  margin-left: 15px;
`;

export const HeadingRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  align-items: center;

  > * {
    margin-right: 15px;
  }

  .loader {
    margin-top: 5px;
    line-height: 1;
  }
`;

export const SidebarButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 15px;

  div {
    flex: 1;
  }

  div ~ button:not(:last-child) {
    margin-right: 10px;
  }

  .loader {
    line-height: 1;
    margin-right: 15px;
    margin-top: 6px;
  }
`;

export const SideForm: React.FunctionComponent<Props> = ({ isLoading, children, onSubmit, onEscape }) => {
  const isEscape = n => n === 27;

  const onKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (!!onEscape && isEscape(e.keyCode)) {
      e.preventDefault();
      onEscape();
    }
  };

  return (
    <FormContainer>
      <form onSubmit={onSubmit} onKeyDown={onKeyDown}>
        {isLoading && <FormLoader />}
        {children}
      </form>
    </FormContainer>
  );
};

export default SideForm;
